import React, { SVGAttributes } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import loadable, { LoadableComponent } from '@loadable/component'
import config from 'constants/config'
import { ResponsiveLogoProps } from './logos/ResponsiveLuxuryEscapesLogo'

const logos: Record<string, LoadableComponent<SVGAttributes<SVGSVGElement>>> = {
  cudo: loadable(() => import(/* webpackChunkName: "CudoGetawaysLogo" */ './logos/CudoGetawaysLogo')),
  cudotravel: loadable(() => import(/* webpackChunkName: "CudoTravellogo" */ './logos/CudoTravelLogo')),
  ouffer: loadable(() => import(/* webpackChunkName: "Oufferlogo" */ './logos/OufferGetawaysLogo')),
  deals: loadable(() => import(/* webpackChunkName: "Dealslogo" */ './logos/DealsGetawaysLogo')),
  dealstravel: loadable(() => import(/* webpackChunkName: "DealsTravellogo" */ './logos/DealsTravelLogo')),
  livingsocial: loadable(() => import(/* webpackChunkName: "LivingSociallogo" */ './logos/LivingsocialGetawaysLogo')),
  treatme: loadable(() => import(/* webpackChunkName: "TreatMelogo" */ './logos/TreatmeLogo')),
  treatmetravel: loadable(() => import(/* webpackChunkName: "TreatMeTravellogo" */ './logos/TreatmeTravelLogo')),
  luxuryescapes: loadable(() => import(/* webpackChunkName: "ResponsiveLuxuryEscapesLogo" */ './logos/ResponsiveLuxuryEscapesLogo')),
  scoopon: loadable(() => import(/* webpackChunkName: "Scooponlogo" */ './logos/ScooponLogo')),
  leagenthub: loadable(() => import(/* webpackChunkName: "LeAgentHubLogo" */ './logos/LeAgentHubLogo')),
  leagenthub_cvfr: loadable(() => import(/* webpackChunkName: "LeAgentHubCVFRLogo" */ './logos/LeAgentHubCVFRLogo')),
}

const LogoComponent = styled.div``

interface Props extends ResponsiveLogoProps {
  className?: string;
  fill?: string;
  height?: number | null | string;
  width?: number | null | string;
}

function LogoIcon(props: Props) {
  const {
    className,
    fill,
    mobileVariant,
    tabletVariant,
    desktopVariant,
    extraLargeDesktopVariant,
    height = config.logo.iconHeight,
    width = config.logo.iconWidth,
  } = props

  const Logo = logos[config.logo.icon]

  return (
    <LogoComponent
      className={className}
      as={Logo as any}
      aria-hidden="true"
      style={{
        maxHeight: typeof height === 'number' ? rem(height) : undefined,
        maxWidth: typeof width === 'number' ? rem(width) : undefined,
      }}
      height={height}
      fill={fill || config.logo.fillColor}
      // Why the conditional spread?
      // Because only ResponsiveLuxuryEscapesLogo understands it.
      {...(config.BRAND === 'luxuryescapes' ? {
        mobileVariant,
        tabletVariant,
        desktopVariant,
        extraLargeDesktopVariant,
      } : {})}
    />
  )
}

export default React.memo(LogoIcon)
